/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Gcg
 */
export class Gcg {
    /**
     *
     * @type {string}
     * @memberof Gcg
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Gcg
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Gcg
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Gcg
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Gcg
     */
    publicKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Gcg
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Gcg
     */
    autoApprove: boolean;
}
